import React from 'react';

function Union({ color, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="16"
      fill="none"
      className={className}
      viewBox="0 0 13 16"
    >
      <path
        fill={color !== '' ? color : '#333'}
        fillRule="evenodd"
        d="M9.525 3.143c0 1.736-1.421 3.143-3.175 3.143-1.753 0-3.174-1.407-3.174-3.143C3.176 1.407 4.597 0 6.35 0c1.754 0 3.175 1.407 3.175 3.143zm1.295 5.852c1.18 1.387 1.842 3.303 1.875 5.41-.617.33-3.183 1.595-6.347 1.595C3.422 16 .666 14.728 0 14.398c.035-2.104.697-4.017 1.875-5.403 1.172-1.379 2.76-2.138 4.473-2.138 1.712 0 3.3.76 4.472 2.138z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Union;
